/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Avatar_AgentInputs */

const en_avatar_agent = /** @type {(inputs: Avatar_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agent`)
};

const de_avatar_agent = /** @type {(inputs: Avatar_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent`)
};

/**
* | output |
* | --- |
* | "agent" |
*
* @param {Avatar_AgentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const avatar_agent = /** @type {((inputs?: Avatar_AgentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Avatar_AgentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_avatar_agent(inputs)
	return en_avatar_agent(inputs)
});